import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser } from "../../actions/authActions";
//import { getAttendeeByUserId, ReSendInvitation, getAttendeeByEmail, getAttendeeByEmailAndUpdate } from "../../actions/attendeeActions"
import { ReSendInvitation, getAttendeeByEmailAndUpdate } from "../../actions/attendeeActions"
import { withRouter } from "react-router-dom";
import materialize from "materialize-css";
import Localization from "../localization/localization";


class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userRegistered: false,
      vip: false,
      vipProcessed: false,
      categoria: "COMPRADOR",
      categoriaDesc: "",
      invitadoId: "",
      asistencia: "VISITANTE"
    };

    this.locale = Localization.getLocalizationInstance(localStorage.getItem("exmi_language"));
    /*
    let categoria = "VISITANTE";
    let asistencia = localStorage.getItem("asistencia");
    if (asistencia !== null) {
      categoria = asistencia;
    }

    if (categoria !== "CONGRESISTA")
      window.location.href = "https://globalfoundry-eurogussmexico.apptl.mx/nuevoRegistro/" + this.props.auth.user.id + "?asistencia=" + categoria;
    */
  }

  onLogoutClick = e => {
    e.preventDefault();
    this.props.logoutUser();
  };

  getCategoryDesc = categoria => {
    if (categoria === "VISITANTE") {
      return ((localStorage.getItem("exmi_language") === "es") ? "INVITADO" : "GUEST");
    }
    else if (categoria === "ESTUDIANTE") {
      return ((localStorage.getItem("exmi_language") === "es") ? "ESTUDIANTE" : "STUDENT");
    }
    return categoria;
  }


  componentDidMount() {
    const { user } = this.props.auth;
  

    getAttendeeByEmailAndUpdate(user.email, user.id)
      .then(response => {
        this.setState({
          userRegistered: (response.data.email.toString() === user.email.toString()),
          categoria: response.data.categoria,
          invitadoId: response.data._id,
          asistencia: localStorage.getItem("asistencia")
        });

        let categoria = "VISITANTE";
        let asistencia = localStorage.getItem("asistencia");
        if (asistencia !== null) {
          categoria = asistencia;
        }

        if (this.state.userRegistered === false && categoria !== "CONGRESISTA") {
          window.location.href = "https://globalfoundry-eurogussmexico.apptl.mx/nuevoRegistro/" + this.props.auth.user.id + "?asistencia=" + categoria+"&lang="+localStorage.getItem("exmi_language");
        } 
      }

      )
      .catch(error => {
        console.log(error);
        let categoria = "VISITANTE";
        let asistencia = localStorage.getItem("asistencia");
        if (asistencia !== null) {
          categoria = asistencia;
        }

        if (this.state.userRegistered === false && categoria !== "CONGRESISTA") {
          window.location.href = "https://globalfoundry-eurogussmexico.apptl.mx/nuevoRegistro/" + this.props.auth.user.id + "?asistencia=" + categoria+"&lang="+localStorage.getItem("exmi_language");
        } 
      });

    /*  
    let categoria = "VISITANTE";
    let asistencia = localStorage.getItem("asistencia");
    if (asistencia !== null) {
      categoria = asistencia;
    }

    if (this.state.userRegistered === false && categoria !== "CONGRESISTA") {
      window.location.href = "https://globalfoundry-eurogussmexico.apptl.mx/nuevoRegistro/" + this.props.auth.user.id + "?asistencia=" + categoria;
    } 
    */
  }

  onUpdateAttendee = e => {
    const { user } = this.props.auth;
    let path = "/comprador/" + user.id;
    this.props.history.push(path);
  }

  onGetQR = e => {
    const { user } = this.props.auth;
    let path = "/qr/" + user.id;
    this.props.history.push(path);
  }

  onAddAttendee = e => {
    //let path = "/comprador";
    //this.props.history.push(path);
    let categoria = "VISITANTE";
    let asistencia = localStorage.getItem("asistencia");
    if (asistencia !== null) {
      categoria = asistencia;
    }
    
    window.location.href = "https://globalfoundry-eurogussmexico.apptl.mx/nuevoRegistro/" + this.props.auth.user.id + "?asistencia=" + categoria;
  }

  onUpdateConferencias = e => {
    let categoria = "VISITANTE";
    let asistencia = localStorage.getItem("asistencia");
    if (asistencia !== null) {
      categoria = asistencia;
    }

    window.location.href = "https://globalfoundry-eurogussmexico.apptl.mx/conferencias/" + this.state.invitadoId +"?asistencia="+categoria;
  }

  onResendInvitation = e => {
    const { user } = this.props.auth;
    ReSendInvitation(user.id)
      .then(res => materialize.toast({ html: this.locale.dashboard_compradorlanding_toast_success }))
      .catch(err => materialize.toast({ html: this.locale.dashboard_compradorlanding_toast_failure }));
  }




  render() {
    const { user } = this.props.auth;

    return (
      <div class="col s12 m12 l8 container center contentaligned valign-wrapper overflowDiv">
        <div class="col s12 m12 l10 center contentaligned valign-wrapper">
          <div>
            <div className="font-face-mb titulo">
              <h3>
                {this.locale.dashboard_compradorlanding_label_hello} {user.name.split(" ")[0]}
              </h3>
            </div>
            <div className="subTitulo">
              <h6>
                {this.state.userRegistered === false ?
                  <>
                    {this.locale.dashboard_dashboard_label_message_success}{" "}
                    {this.locale.auth_landingsuccess_label_app_name}👏
                  </>
                  :
                  <>
                    { 
                      <>
                        {this.locale.dashboard_dashboard_label_message_registryconfirmation} 👏
                      </>
                    /*
                      this.state.categoria === "COMPRADOR" ?
                      <>
                        {this.locale.dashboard_dashboard_label_message_registryconfirmation} 👏
                      </>
                      :
                      <>
                        {this.locale.dashboard_dashboard_label_message_registryconfirmation_non_buyer}{" "}<b>{this.getCategoryDesc(this.state.categoria)}</b> 👏
                      </>
                      */
                    }
                  </>
                }
              </h6>
            </div>
            <br />
            <br />
            {
             this.state.userRegistered === true ?
              <>
                { 
                  this.state.asistencia === "CONGRESISTA" ?
                  <>
                <div className="font-face-mb titulo">
                  <h4>
                    {this.locale.dashboard_dashboard_button_Conferencias}
                  </h4>
                </div>
                <div className="subTitulo">
                  <h6>
                    {this.locale.dashboard_dashboard_button_ActualizaConferenciasMensaje}
                  </h6>
                </div>
                <div className="col s12 m12 l12">
                  <button
                    style={{
                      width: "350px",
                      borderRadius: "3px",
                      letterSpacing: "1.5px",
                      marginTop: "1rem"
                    }}
                    onClick={this.onUpdateConferencias}
                    className="btn-large hoverable buttonBackgroundColor font-face-msb"
                  >
                    {this.locale.dashboard_dashboard_button_ActualizaConferencias}
                  </button>
                </div>
                    <br />
                    <br />
                    <br />
                    <br />
                  </>
                  :
                  <>
                  </>
                  
              }

                <div className="font-face-mb titulo">
                  <h4>
                    {this.locale.dashboard_dashboard_button_resendinvitation}
                  </h4>
                </div>
                <div className="subTitulo">
                  <h6>
                    {this.locale.dashboard_dashboard_reenviar_invitacion}
                  </h6>
                </div>
                <div className="col s12 m12 l12">
                  <button
                    style={{
                      width: "300px",
                      borderRadius: "3px",
                      letterSpacing: "1.5px",
                      marginTop: "1rem"
                    }}
                    onClick={this.onResendInvitation}
                    className="btn-large hoverable buttonBackgroundColor font-face-msb"
                  >
                    {this.locale.dashboard_dashboard_button_resendinvitation}
                  </button>
                </div>
                <div className="col s12 m12 l12">
                  <button
                    style={{
                      width: "300px",
                      borderRadius: "3px",
                      letterSpacing: "1.5px",
                      marginTop: "1rem"
                    }}
                    onClick={this.onGetQR}
                    className="btn-large hoverable buttonBackgroundColor font-face-msb"
                  >
                    {this.locale.dashboard_dashboard_button_qr}
                  </button>
                </div>                
              </>
              :
              <>
                <div className="font-face-mb titulo">
                  <h4>
                    {this.locale.dashboard_dashboard_button_register}
                  </h4>
                </div>
                <div className="subTitulo">
                  <h6>
                    {this.locale.dashboard_dashboard_message}
                  </h6>
                </div>
                <div className="col s12 m12 l12">
                  <button
                    style={{
                      width: "350px",
                      borderRadius: "3px",
                      letterSpacing: "1.5px",
                      marginTop: "1rem"
                    }}
                    onClick={this.onAddAttendee}
                    className="btn-large hoverable buttonBackgroundColor font-face-msb"
                  >
                    {this.locale.dashboard_dashboard_button_register}
                  </button>
                </div>
              </>
            }
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <div className="col s12 m12 l12">
              <button
                style={{
                  width: "220px",
                  borderRadius: "3px",
                  letterSpacing: "1.5px",
                  marginTop: "1rem"
                }}
                onClick={this.onLogoutClick}
                className="btn hoverable buttonSoporteBackgroundColor font-face-msb"
              >
                {this.locale.dashboard_dashboard_button_logout}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Dashboard.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(
  mapStateToProps,
  { logoutUser }
)(withRouter(Dashboard));
